webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Dashboard__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_messages_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_people_router__ = __webpack_require__(28);





var baseRoutes = [{
  path: '/dashboard',
  name: 'dashboard',
  title: 'Dashboard',
  icon: 'fa-tachometer',
  component: __WEBPACK_IMPORTED_MODULE_1__views_Dashboard___default.a
}, {
  path: '*',
  redirect: { name: 'dashboard' }
}];

var routes = baseRoutes.concat(__WEBPACK_IMPORTED_MODULE_2__modules_messages_router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modules_people_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_messages_store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_people_store__ = __webpack_require__(31);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    messages: __WEBPACK_IMPORTED_MODULE_3__modules_messages_store__["a" /* default */],
    people: __WEBPACK_IMPORTED_MODULE_4__modules_people_store__["a" /* default */]
  },
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({
    key: 'kazoo'
  })],
  strict: debug,
  state: {
    count: 0
  },
  mutations: {
    updateCount: function updateCount(state, payload) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'count', state.count + payload);
    }
  },
  getters: {
    getCount: function getCount(state) {
      return state.count;
    }
  },
  actions: {
    incrementCount: function incrementCount(context) {
      context.commit('updateCount', 1);
    },
    decrementCount: function decrementCount(context) {
      context.commit('updateCount', -1);
    }
  }
}));

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_route_timeline__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(18);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-83598448-1',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: '/kazoo' + route.path,
        title: document.title,
        location: window.location.href
      };
    }
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_route_timeline__["a" /* default */].plugin, { store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Messages__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Welcome__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Details__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Details__);




/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/messages',
  name: 'messages',
  component: __WEBPACK_IMPORTED_MODULE_0__views_Messages___default.a,
  title: 'Messages',
  icon: 'fa-comments',
  redirect: { name: 'messages-welcome' },
  children: [{
    path: 'welcome',
    name: 'messages-welcome',
    component: __WEBPACK_IMPORTED_MODULE_1__views_Welcome___default.a
  }, {
    path: ':id',
    name: 'messages-details',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Details___default.a
  }]
}]);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  readItem: function readItem(state, item) {
    setTimeout(function () {
      return state.commit('itemIsRead', { item: item });
    }, 500);
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getItems: function getItems(state) {
    return state.items;
  },
  getItem: function getItem(state) {
    return function (payload) {
      return state.items.find(function (item) {
        return item.id === payload.id;
      });
    };
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    items: [{
      id: '5eb76728-3a7d-11e7-a919-92ebcb67fe33',
      name: 'In in justo in ipsum lobortis',
      content: '<p>Morbi pulvinar sem in enim dignissim, vel ornare ligula sagittis. In in justo in ipsum lobortis consequat et non tortor. Proin et tempus ex. Proin consectetur eros a sapien tempor consequat. Cras rhoncus massa nec nulla hendrerit, vel hendrerit dui hendrerit. Maecenas gravida euismod velit eget dictum. Proin imperdiet dictum erat at dapibus. Sed nec metus tortor. Maecenas egestas ut risus id rutrum. Aenean non ipsum mauris. Proin volutpat risus eget enim auctor commodo. Morbi hendrerit convallis ex. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vivamus accumsan magna sit amet arcu porta, id pretium mauris varius. Integer nisi enim, blandit nec fermentum at, pharetra mollis lorem.</p>',
      read: true
    }, {
      id: '5eb76a84-3a7d-11e7-a919-92ebcb67fe33',
      name: 'Phasellus et quam sagittis',
      content: '<p>Quisque condimentum est ut orci sodales, vitae gravida urna efficitur. Phasellus et quam sagittis, consequat velit nec, consectetur tortor. Suspendisse id faucibus diam. Phasellus eget aliquet augue. Proin ultricies faucibus metus eget scelerisque. Praesent eu lacus mauris. Maecenas vitae enim sem. Nam sit amet convallis eros. Sed congue id ex nec eleifend. Nulla porta libero at massa posuere pellentesque. Aenean tincidunt turpis nibh, sed dictum risus blandit in. Vestibulum congue finibus odio, ac auctor erat dapibus at. Fusce molestie purus vel mi venenatis, ut mollis dui dapibus. Donec ultricies tincidunt quam, at auctor metus ultrices ac.</p>',
      read: false
    }, {
      id: '5eb76c50-3a7d-11e7-a919-92ebcb67fe33',
      name: 'Praesent in porttitor lorem',
      content: '<p>Aliquam mattis semper mauris vitae placerat. Curabitur interdum quam id mi mattis efficitur. Etiam at arcu tortor. Praesent in porttitor lorem, tempor hendrerit nulla. Donec dapibus blandit velit vel vehicula. Nulla sit amet pretium turpis, id consectetur diam. Curabitur lacinia tincidunt est a sodales. Suspendisse faucibus quam vitae venenatis eleifend. Mauris blandit, nunc eu sodales scelerisque, elit erat porttitor ligula, in volutpat massa libero quis felis. Suspendisse volutpat tellus eu ullamcorper feugiat. </p>',
      read: false
    }]
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  itemIsRead: function itemIsRead(state, payload) {
    var item = state.items.find(function (i) {
      return i.id === payload.item.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'read', true);
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_People__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_People___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_People__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Welcome__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Details__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Details__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Create__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Edit__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/people',
  name: 'people',
  component: __WEBPACK_IMPORTED_MODULE_0__views_People___default.a,
  title: 'People',
  icon: 'fa-users',
  redirect: { name: 'people-welcome' },
  children: [{
    path: 'welcome',
    name: 'people-welcome',
    component: __WEBPACK_IMPORTED_MODULE_1__views_Welcome___default.a
  }, {
    path: 'create',
    name: 'people-create',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Create___default.a
  }, {
    path: ':id',
    name: 'people-details',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Details___default.a
  }, {
    path: ':id/edit',
    name: 'people-edit',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Edit___default.a
  }]
}]);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  addPerson: function addPerson(state, person) {
    setTimeout(function () {
      return state.commit('personIsAdded', { person: person });
    }, 500);
  },
  patchPerson: function patchPerson(state, person) {
    setTimeout(function () {
      return state.commit('personIsPatched', { person: person });
    }, 500);
  },
  removePerson: function removePerson(state, personId) {
    setTimeout(function () {
      return state.commit('personIsRemoved', { personId: personId });
    }, 500);
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getItems: function getItems(state) {
    return state.items;
  },
  getItem: function getItem(state) {
    return function (payload) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.items.find(function (item) {
        return item.id === payload.id;
      }));
    };
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    items: [{
      id: '8d77b83a-c28e-430f-9177-8b443975d210',
      name: 'Charles C. Swain',
      phone: '615-233-5488',
      function: 'Director of photography',
      image: 'static/male.svg'
    }, {
      id: '6db8bb80-25d3-48f5-bea1-5e1215e9b3b7',
      name: 'Nick M. Wright',
      phone: '423-349-9091',
      function: 'Director of fun',
      image: 'static/male.svg'
    }, {
      id: 'e2e412b8-7c1a-46d5-8841-5fae4b4b9a9a',
      name: 'Gladys T. Garrett',
      phone: '661-469-8833',
      function: 'Manager',
      image: 'static/female.svg'
    }]
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  personIsAdded: function personIsAdded(state, payload) {
    state.items.push(payload.person);
  },
  personIsPatched: function personIsPatched(state, payload) {
    var person = payload.person;

    var items = state.items.map(function (item) {
      return item.id === person.id ? person : item;
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'items', items);
  },
  personIsRemoved: function personIsRemoved(state, payload) {
    var items = state.items.filter(function (item) {
      return item.id !== payload.personId;
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'items', items);
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'route-timeline',
  computed: {
    items: function items() {
      return this.$store.getters['timeline/getItems'];
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default.a },
  name: 'app'
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  computed: {
    routes: function routes() {
      var _this = this;

      var routes = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$router.options.routes).forEach(function (key) {
        var route = _this.$router.options.routes[key];
        if (route.title) {
          routes.push(route);
        }
      });
      return routes;
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'the-counter',
  computed: {
    count: function count() {
      return this.$store.getters.getCount;
    }
  },
  methods: {
    incrementCount: function incrementCount() {
      this.$store.dispatch('incrementCount');
    },
    decrementCount: function decrementCount() {
      this.$store.dispatch('decrementCount');
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'messages-details',
  computed: {
    item: function item() {
      return this.$store.getters['messages/getItem'](this.$route.params);
    }
  },
  methods: {
    isItemRead: function isItemRead(item) {
      if (!item.read) {
        this.$store.dispatch('messages/readItem', item);
      }
    },
    addTimeline: function addTimeline() {
      this.$routeTimeline.set(this.item.name, 'Message');
    }
  },
  mounted: function mounted() {
    this.isItemRead(this.item);
    this.addTimeline();
  },

  watch: {
    item: function item(_item) {
      this.isItemRead(_item);
      this.addTimeline();
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'messages',
  computed: {
    items: function items() {
      return this.$store.getters['messages/getItems'];
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'messages-welcome',
  mounted: function mounted() {
    this.$routeTimeline.set('Messages', 'All the messages');
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var uuidv4 = __webpack_require__(79);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-create',
  data: function data() {
    return {
      person: {
        id: uuidv4(),
        name: '',
        phone: '',
        function: '',
        image: 'static/male.svg'
      }
    };
  },

  methods: {
    addPerson: function addPerson() {
      this.$store.dispatch('people/addPerson', this.person);
      this.person = {
        id: uuidv4(),
        name: '',
        phone: '',
        function: '',
        image: 'static/male.svg'
      };
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-details',
  computed: {
    person: function person() {
      return this.$store.getters['people/getItem'](this.$route.params);
    }
  },
  methods: {
    removePerson: function removePerson() {
      this.$store.dispatch('people/removePerson', this.person.id);
      this.$router.push({
        name: 'people-welcome'
      });
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-details',
  computed: {
    person: function person() {
      return this.$store.getters['people/getItem'](this.$route.params);
    }
  },
  methods: {
    patchPerson: function patchPerson() {
      this.$store.dispatch('people/patchPerson', this.person);
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people',
  computed: {
    items: function items() {
      return this.$store.getters['people/getItems'];
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-welcome',
  mounted: function mounted() {
    this.$routeTimeline.set('People', 'I see people');
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheCounter__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheCounter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TheCounter__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: {
    TheCounter: __WEBPACK_IMPORTED_MODULE_0__components_TheCounter___default.a
  },
  mounted: function mounted() {
    this.$routeTimeline.set('Dashboard', 'Im on a dashboard');
  },
  data: function data() {
    return {
      msg: 'Kazoo admin'
    };
  }
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            Welcome\n        ")])]), _vm._v(" "), _c('h1', [_vm._v("Welcome")]), _vm._v(" "), _c('p', [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab accusantium assumenda dolor eligendi enim eos, impedit in ipsum laboriosam maxime mollitia natus necessitatibus neque, odit quia, quibusdam sed soluta totam.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'messages'
      }
    }
  }, [_vm._v("\n                mail\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            Welcome\n        ")])]), _vm._v(" "), _c('h1', [_vm._v("Welcome")]), _vm._v(" "), _c('p', [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab accusantium assumenda dolor eligendi enim eos, impedit in ipsum laboriosam maxime mollitia natus necessitatibus neque, odit quia, quibusdam sed soluta totam.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_vm._l((_vm.items), function(item) {
    return _vm._t("item", [_c('router-link', {
      staticClass: "timeline-item",
      attrs: {
        "to": item.route
      }
    }, [_c('h5', {
      staticClass: "timeline-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "timeline-subtitle"
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {
      staticClass: "timeline-date"
    }, [_vm._v(_vm._s(_vm._f("timelineDate")(item.created)))])])], {
      title: item.title,
      subtitle: item.subtitle,
      created: item.created,
      route: item.route
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "tabbar tabbar-toggleable-md"
  }, [_c('router-link', {
    staticClass: "tabbar-brand",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("\n        Kazoo\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "tabbar-nav bg-light"
  }, _vm._l((_vm.routes), function(route) {
    return _c('li', {
      staticClass: "tabbar-item"
    }, [_c('router-link', {
      staticClass: "tabbar-link text-dark",
      attrs: {
        "to": route,
        "active-class": "active"
      }
    }, [_c('i', {
      staticClass: "fa tabbar-icon",
      class: route.icon
    }), _vm._v("\n                " + _vm._s(route.title) + "\n            ")])], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xl-3 bg-info vh-100"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: "item.id",
      staticClass: "py-1"
    }, [_c('router-link', {
      staticClass: "d-block text-white",
      class: {
        'font-weight-bold': !item.read
      },
      attrs: {
        "to": {
          name: 'messages-details',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n            ")])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xl-9 vh-100"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "admin-sidebar bg-light"
  }, [_c('navbar')], 1), _vm._v(" "), _c('div', {
    staticClass: "admin-body",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary",
    on: {
      "click": function($event) {
        _vm.decrementCount()
      }
    }
  }, [_vm._v("subtract one")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary",
    on: {
      "click": function($event) {
        _vm.incrementCount()
      }
    }
  }, [_vm._v("add one")])])
},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            Add person\n        ")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addPerson()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.name),
      expression: "person.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-name"
    },
    domProps: {
      "value": (_vm.person.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.phone),
      expression: "person.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-phone"
    },
    domProps: {
      "value": (_vm.person.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.function),
      expression: "person.function"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-function"
    },
    domProps: {
      "value": (_vm.person.function)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.function = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Add person\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'messages'
      }
    }
  }, [_vm._v("\n                mail\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n        ")])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            " + _vm._s(_vm.person.name) + "\n        ")])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.person.name))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.person.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.person.phone) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.person.function) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'people-edit',
        params: {
          id: _vm.person.id
        }
      }
    }
  }, [_vm._v("\n            edit\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removePerson()
      }
    }
  }, [_vm._v("remove")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xl-3 bg-dark vh-100"
  }, [_c('div', {
    staticClass: "py-3"
  }, [_c('router-link', {
    staticClass: "btn btn-outline-primary btn-block",
    attrs: {
      "to": {
        name: 'people-create'
      }
    }
  }, [_vm._v("Add person")])], 1), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('router-link', {
      key: "item.id",
      staticClass: "row py-2",
      attrs: {
        "to": {
          name: 'people-details',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "col-3 col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid rounded-circle bg-faded img-thumbnail",
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-9 col-md-8 text-white"
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    " + _vm._s(item.function) + "\n                ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xl-9 vh-100"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('h3', [_vm._v("The timeline")]), _vm._v(" "), _c('route-timeline')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h3', [_vm._v("The counter")]), _vm._v(" "), _c('the-counter')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            " + _vm._s(_vm.person.name) + "\n        ")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.patchPerson()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.name),
      expression: "person.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-name"
    },
    domProps: {
      "value": (_vm.person.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.phone),
      expression: "person.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-phone"
    },
    domProps: {
      "value": (_vm.person.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.function),
      expression: "person.function"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-function"
    },
    domProps: {
      "value": (_vm.person.function)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.function = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Update person\n        ")])])])
},staticRenderFns: []}

/***/ })
],[22]);


// WEBPACK FOOTER //
// static/js/app.cf2fddc384066c82d9d8.js